import { BaseModel } from '@shared/models/entity/base/base.model';

export type UserNotificationType = 'TaskAssigned' | 'TaskMentioned' | 'TaskCommented' | 'TaskDueToday';

/**
 * One in-app notification for the current employee (Zuweisung, @-Erwähnung, Fälligkeit) —
 * the rows behind the bell in the toolbar.
 */
export class UserNotification extends BaseModel {
  /** Drives the inbox icon. */
  type: UserNotificationType;

  title: string;

  body: string;

  /** The deep-link target ("Task", "Document") — null for free-standing notices. */
  entityType: string;

  entityId: string;

  /** Who caused the notification — display name. */
  actorName: string;

  /** ISO instant — null while unread. */
  readAt: string | null;

  get isUnread(): boolean {
    return this.readAt === null || this.readAt === undefined || this.readAt === '';
  }

  constructor(init?: Partial<UserNotification>) {
    super(init);
    if (init) { Object.assign(this, init); }
  }
}
